const OVERVIEW_ROUTE_PATTERN =
    "/:locale(pt|en|lt)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId";
const LEGACY_MODULE_PREFIX_SEGMENT = "/:modulePrefix";

const normalizeChartLink = (link) => {
    if (!link || typeof link !== "object") {
        return;
    }

    if (link.filterColumn && !link.category) {
        link.category = link.filterColumn;
    }
};

const appendViewModeQuery = (path, viewMode) => {
    if (!viewMode || path.includes("viewMode=")) {
        return path;
    }

    const separator = path.includes("?") ? "&" : "?";
    return `${path}${separator}viewMode=${viewMode}`;
};

const isRoutePattern = (path) => typeof path === "string" && path.startsWith("/") && path.includes(":");

const isPieDrillDownLink = (path) =>
    typeof path === "string" && /\/:id(\?viewMode=|$)/.test(path);

const resolveStringNavigationLink = (newNavigationLink, viewMode) => {
    if (isPieDrillDownLink(newNavigationLink)) {
        return newNavigationLink.replace(/\?viewMode=[^&]+$/, "");
    }

    return appendViewModeQuery(newNavigationLink, viewMode);
};

const deriveNewNavigationPathFromLegacy = (legacyPath, viewMode) => {
    const pathWithoutModulePrefix = legacyPath.includes(LEGACY_MODULE_PREFIX_SEGMENT)
        ? legacyPath.replace(LEGACY_MODULE_PREFIX_SEGMENT, "")
        : legacyPath;

    return appendViewModeQuery(pathWithoutModulePrefix, viewMode);
};

const resolveWidgetLink = (link, viewMode, hasNewNavigation) => {
    if (!link || typeof link !== "object") {
        return;
    }

    if (hasNewNavigation) {
        if (typeof link.newNavigationLink === "string") {
            link.to = appendViewModeQuery(link.newNavigationLink, viewMode);
            delete link.newNavigationLink;
            link.createLink = true;
            return;
        }

        if (isRoutePattern(link.to)) {
            link.to = deriveNewNavigationPathFromLegacy(link.to, viewMode);
            link.createLink = true;
            return;
        }

        if (typeof link.to === "string" && !link.to.startsWith("/")) {
            const entity = link.to.replace(/^\//, "");
            link.to = appendViewModeQuery(
                `${OVERVIEW_ROUTE_PATTERN}/transactional_data/${entity}`,
                viewMode,
            );
            link.createLink = true;
        }

        return;
    }

    if (isRoutePattern(link.to)) {
        link.createLink = true;
    }
};

const resolveNode = (node, viewMode, hasNewNavigation) => {
    if (!node || typeof node !== "object") {
        return;
    }

    if (Array.isArray(node)) {
        node.forEach((child) => resolveNode(child, viewMode, hasNewNavigation));
        return;
    }

    if (hasNewNavigation && typeof node.newNavigationLink === "string") {
        node.link = resolveStringNavigationLink(node.newNavigationLink, viewMode);
        delete node.newNavigationLink;
    }

    resolveWidgetLink(node.link, viewMode, hasNewNavigation);

    if (hasNewNavigation && Array.isArray(node.newNavigationLinks) && node.newNavigationLinks.length > 0) {
        node.links = node.newNavigationLinks;
        delete node.newNavigationLinks;
    }

    if (Array.isArray(node.links)) {
        node.links.forEach(normalizeChartLink);
    }

    Object.values(node).forEach((child) => resolveNode(child, viewMode, hasNewNavigation));
};

export const resolveOverviewLayoutLinks = (layout, hasNewNavigation, viewMode) => {
    if (!Array.isArray(layout) || layout.length === 0) {
        return layout;
    }

    resolveNode(layout, viewMode, hasNewNavigation);
    return layout;
};
